// extracted by mini-css-extract-plugin
export default {"navMenuList":"NavMenuList_navMenuList__EWPTm","navMenuItem":"NavMenuList_navMenuItem__VNBzk","tab":"NavMenuList_tab__2H-3d"};